import { Button, Modal } from 'antd';
import { useAtom } from 'jotai';
import { ieltsThemeAtom } from '@/store/home';
import { IeltsTheme } from '@/types';

type Props = {
  open?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
};

export default function ClassicModal({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  description,
  confirmText,
  cancelText,
  loading,
}: Props) {
  const [ieltsTheme] = useAtom(ieltsThemeAtom);
  const isGamingTheme = ieltsTheme === IeltsTheme.GAMIFICATION;

  const buttonStyle = {
    backgroundColor: 'var(--ielts-accent-bg)',
    borderColor: 'var(--ielts-accent-bg)',
    color: 'var(--ielts-on-accent)',
    boxShadow: !isGamingTheme ? 'none' : '0px 4px 10px rgba(0, 0, 0, 0.1)',
  };

  return (
    <Modal
      open={open}
      closable={!!onClose}
      onCancel={loading ? undefined : onClose}
      footer={null}
      title={null}
    >
      {title && (
        <h3 className="text-[24px] font-semibold text-center mb-6 text-black">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-black text-lg font-medium text-center mb-10">{description}</p>
      )}
      <div className="flex items-center justify-center gap-7">
        {onConfirm && (
          <Button
            type="primary"
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
            className="w-[200px]"
            size="large"
            style={buttonStyle}
          >
            {confirmText}
          </Button>
        )}
        {onCancel && (
          <Button onClick={onCancel} loading={loading} className="w-[200px]" size="large">
            {cancelText}
          </Button>
        )}
      </div>
    </Modal>
  );
}
